import Loading from '../Loading';
import { getDistanceLabel } from '../../utils/dropOffLocations';
import { getGoLockerLocationName } from '../../utils/goLocker';
import { GoLockerAvailability } from './GoLockerLocationRow';

import styles from './GoLocker.module.scss';

/**
 * GoLockerNearest — the label card's drop-off block for a GoLocker label (Figma "TBB
 * label card · GoLocker" 12259:7987):
 *
 *   Nearest: GoLocker · 230 Park Ave
 *   Park Ave & E 46th St | 0.2 miles
 *   Open now · M 4 · L 2 · XL 1
 *          Check live availability
 *
 * Unlike the carrier block it keeps the link alongside the nearest bank: lockers
 * fill up, so the live finder is the point, not a fallback for missing locations.
 * A failed / empty lookup leaves just the link.
 */
const GoLockerNearest = ({ loading, locations = [], findLocation }) => {
  if (loading) {
    return (
      <div className={styles.nearestLoading}>
        <Loading size={20} />
      </div>
    );
  }

  const [nearest] = locations;
  const distance = getDistanceLabel(nearest?.distance);
  const secondLine = [nearest?.accessInstructions, distance].filter(Boolean).join(' | ');

  return (
    <div className={styles.nearest}>
      {nearest && (
        <div className={styles.nearestMain}>
          <span className={styles.nearestName}>{`Nearest: ${getGoLockerLocationName(nearest)}`}</span>
          {secondLine && <span className={styles.nearestMeta}>{secondLine}</span>}
          <GoLockerAvailability
            availability={nearest.availability}
            className={styles.nearestAvailability}
          />
        </div>
      )}
      {findLocation && (
        <a
          className={styles.nearestLink}
          href={findLocation}
          target="_blank"
          rel="noopener noreferrer"
        >
          Check live availability
        </a>
      )}
    </div>
  );
};

export default GoLockerNearest;
